<script lang="ts" setup>
import pumpkinSvg from '@shared/ui/images/upsell-halloween/pumpkin.svg'
import titleSvg from '@shared/ui/images/upsell-halloween/title.svg'
import titleMobileSvg from '@shared/ui/images/upsell-halloween/title-mobile.svg'

defineOptions({
  name: 'BannerUpsellTitle',
})

defineProps<{
  title: string
  titleMobile: string
}>()
</script>

<template>
  <div class="banner-upsell-title">
    <span class="banner-upsell-title__pumpkin">
      <img
        :src="pumpkinSvg"
        class="banner-upsell-title__image"
        alt="Smiling Halloween pumpkin"
      >
    </span>
    <span class="banner-upsell-title__lettering banner-upsell-title__lettering--mobile">
      <img
        :src="titleMobileSvg"
        class="banner-upsell-title__image"
        :alt="titleMobile"
      >
    </span>
    <span class="banner-upsell-title__lettering banner-upsell-title__lettering--full">
      <img
        :src="titleSvg"
        class="banner-upsell-title__image"
        :alt="title"
      >
    </span>
  </div>
</template>

<style scoped lang="scss" src="./BannerUpsellTitle.scss" />
